import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResetPasswordFormTW } from '../../components/auth/ResetPasswordFormTW';
import { useLenis } from '../../hooks/useLenis';

export const ResetPasswordPageTW: React.FC = () => {
  useLenis();
  const navigate = useNavigate();

  return (
    <ResetPasswordFormTW
      onBackToLogin={() => navigate('/login')}
    />
  );
};
